import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { AnnouncementWithRelationsDto, ResponseDto } from "@mimber/schema"
import { announcementsKeys } from "../announcements.utils"
import type { ScheduleAnnouncementParams } from "./useScheduleAnnouncement.types"

export const useScheduleAnnouncement = (
  options?: UseMutationOptions<
    ResponseDto<AnnouncementWithRelationsDto>,
    Error,
    ScheduleAnnouncementParams
  >
): UseMutationResult<
  ResponseDto<AnnouncementWithRelationsDto>,
  Error,
  ScheduleAnnouncementParams
> => {
  guardAppUsage("mimber-organization", "useScheduleAnnouncement")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async ({
      uuid,
      scheduledPublishAt,
    }: ScheduleAnnouncementParams) => {
      const response = await server.post<
        ResponseDto<AnnouncementWithRelationsDto>
      >(`announcements/${uuid}/schedule`, { scheduledPublishAt })
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: announcementsKeys.findOne(variables.uuid),
      })
      queryClient.invalidateQueries({
        queryKey: announcementsKeys.findAll(),
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
